import OutputXmcPinEditorContainer from './OutputXmcPinEditorContainer'

export default OutputXmcPinEditorContainer
